import { connect } from 'react-redux'
import {
  pageRenderLeft,
  pageToggleOverlay,
  setSelectedDeals
} from 'redux/actions'
import FiltersPanel from 'pages/mwlistdeals/filters'

const mapStateToProps = state => ({
  selectedDeals: state.dealwatch.selectedDeals,
  selectedDealType: state.dealwatch.selectedDealType,
  browser: state.layout.browser,
  isLargeDesktop: state.layout.deviceType.isLargeDesktop,
  windowWidth: state.layout.windowWidth,
  isLimitedAccess: state.user.isLimitedAccess
})

const mapDispatchToProps = dispatch => ({
  pageRenderLeft: component => dispatch(pageRenderLeft(component)),
  pageToggleOverlay: component => dispatch(pageToggleOverlay(component)),
  setSelectedDeals: ({ select, deselect, dealType }) => {
    dispatch(setSelectedDeals({ select, deselect, dealType }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(FiltersPanel)
